import React from "react";
import { Text, View } from "react-native";

import appStyles from "../../../appStyles";
import styles from "./integrationStyles";
import { getProfileFromEmail, pluralize } from "../../../../helpers/utils";
import IntegrationDateTime from "./IntegrationDateTime";

export default function ChromeIntegration(props) {
  const { data } = props;
  const source = data?.source || {};
  const numberOfSites = (data.details || []).length;
  const mediaText = data.name;

  return (
    <View>
      {/* Line 1 */}
      <Text style={styles.integrationName} numberOfLines={1} title={mediaText}>
        {mediaText}
      </Text>

      {/* Line 2 */}
      <View
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {source.profile ? (
          <Text style={appStyles.captionThin}>
            {getProfileFromEmail(source.profile)} •
          </Text>
        ) : null}

        {numberOfSites ? (
          <Text style={appStyles.captionThin}>
            {pluralize("site", numberOfSites)}
          </Text>
        ) : null}

        <IntegrationDateTime
          {...props}
          source={source}
          hasSourceInfo={numberOfSites}
        />
      </View>
    </View>
  );
}
